import api from "../utils/api";
import { toast } from "react-toastify";

const CustomerTable = ({
  customers,
  onEdit,
  onRefresh,
  onViewTransactions,
  showDeleted = false,
}) => {
  const handleDelete = async (id) => {
    if (!window.confirm("Are you sure you want to delete this customer?"))
      return;

    try {
      await api.delete(`/customers/${id}`);
      toast.success("Customer deleted");
      onRefresh();
    } catch (err) {
      toast.error("Failed to delete");
    }
  };

  const handleRestore = async (id) => {
    try {
      await api.put(`customers/restore/${id}`);
      toast.success("Customer restored");
      onRefresh();
    } catch (err) {
      toast.error("Failed to restore");
    }
  };

  const getLoyaltyTag = (totalSpent) => {
    if (totalSpent >= 20000)
      return (
        <span className="bg-purple-100 text-purple-700 px-2 py-1 rounded text-xs font-semibold">
          VIP
        </span>
      );

    return (
      <span className="bg-gray-100 text-gray-700 px-2 py-1 rounded text-xs">
        Regular
      </span>
    );
  };

  if (!customers.length) {
    return (
      <div className="text-center py-8 text-gray-500">
        No customers found
      </div>
    );
  }

  return (
    <div className="overflow-x-auto bg-white shadow rounded-lg">
      <table className="w-full text-sm">
        <thead className="bg-gray-100 text-left">
          <tr>
            <th className="p-3">Name</th>
            <th className="p-3">Mobile</th>
            <th className="p-3">Email</th>
            <th className="p-3">Total Spent</th>
            <th className="p-3">Last Visit</th>
            <th className="p-3 text-right">🌟 Points</th>
            <th className="p-3 text-right">👛 Wallet</th>
            <th className="p-3 text-center">Actions</th>
          </tr>
        </thead>

        <tbody>
          {customers.map((cust) => (
            <tr
              key={cust._id}
              className="border-t hover:bg-gray-50 transition"
            >
              <td className="p-3 font-medium">{cust.name}</td>

              <td className="p-3">{cust.mobile}</td>

              <td className="p-3">
                {cust.email || <span className="text-gray-400">-</span>}
              </td>

              <td className="p-3 font-semibold text-green-600">
                ₹{(cust.totalSpent || 0).toFixed(2)}
              </td>

              <td className="p-3">
                {cust.lastVisit
                  ? new Date(cust.lastVisit).toLocaleDateString()
                  : "-"}
              </td>

              <td className="p-3 text-right">
                <span className={`font-semibold ${(cust.loyaltyPoints || 0) > 0 ? "text-indigo-600" : "text-gray-400"}`}>
                  {cust.loyaltyPoints || 0}
                </span>
              </td>

              <td className="p-3 text-right">
                <span className={`font-semibold ${(cust.walletBalance || 0) > 0 ? "text-emerald-600" : "text-gray-400"}`}>
                  ₹{(cust.walletBalance || 0).toFixed(2)}
                </span>
              </td>

              <td className="p-3 text-center space-x-2">
                {!cust.isDeleted ? (
                  <>
                    <button
                      onClick={() => onViewTransactions(cust)}
                      className="text-indigo-600 hover:underline text-xs"
                    >
                      Transactions
                    </button>

                    <button
                      onClick={() => onEdit(cust)}
                      className="text-blue-600 hover:underline text-xs"
                    >
                      Edit
                    </button>

                    <button
                      onClick={() => handleDelete(cust._id)}
                      className="text-red-600 hover:underline text-xs"
                    >
                      Delete
                    </button>
                  </>
                ) : (
                  <button
                    onClick={() => handleRestore(cust._id)}
                    className="text-green-600 hover:underline text-xs"
                  >
                    Restore
                  </button>
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default CustomerTable;
